var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('input-checkbox');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { TickIcon } from '@shapeable/icons';
export var InputCheckboxDefaultProps = {
  checked: false,
  name: 'checkbox',
  required: false,
  value: 'yes',
  valid: true,
  icon: TickIcon,
  onChange: function () {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    font-weight: 400;\n    color: ", ";\n    font-size: 0.85em;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    font-weight: 400;\n    color: ", ";\n    font-size: 0.85em;\n\n    ", "\n  "])), theme.COLOR('text'), function (props) {
    return !props.valid && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('error'));
  }),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var InputStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    left: -9999px;\n  "], ["\n    position: absolute;\n    left: -9999px;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 14px;\n    height: 14px;\n    ", ";\n  "], ["\n    width: 14px;\n    height: 14px;\n    ", ";\n  "])), theme.FILL('primary'))
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    border: 2px dotted ", ";\n    width: 22px;\n    height: 22px;\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    margin-left: ", ";\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    ", "\n  "], ["\n    border: 2px dotted ", ";\n    width: 22px;\n    height: 22px;\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    margin-left: ", ";\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    ", "\n  "])), theme.COLOR('line-mid'), theme.UNIT(3), theme.COLOR('primary'), function (props) {
    return !props.valid && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), theme.COLOR('error'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""]))),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Checkbox: styled.div.attrs(cls.attr('checkbox'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles),
  ActualInput: styled.input(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])))
};
My.Container = styled.label(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n  &:hover ", " {\n    border-color: ", ";\n  }\n"], ["\n  ", "\n  &:hover ", " {\n    border-color: ", ";\n  }\n"])), ContainerStyles, My.Checkbox, theme.COLOR('link-hover'));
My.ActualInput = styled.input(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n  &:focus ~ ", " {\n    transition: border-color 0.25s;\n    border-color: ", ";\n  }\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n"], ["\n  ", "\n  &:focus ~ ", " {\n    transition: border-color 0.25s;\n    border-color: ", ";\n  }\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n"])), InputStyles, My.Checkbox, theme.COLOR('link-hover'), My.Label, theme.COLOR('secondary'));
export var InputCheckbox = function (props) {
  var className = props.className,
    value = props.value,
    name = props.name,
    id = props.id,
    onChange = props.onChange,
    label = props.label,
    icon = props.icon,
    checked = props.checked,
    valid = props.valid,
    required = props.required,
    children = props.children;
  var Icon = icon;
  var handleChange = onChange && function (event) {
    onChange(checked ? '' : value);
  };
  return React.createElement(My.Container, {
    valid: valid,
    className: cls.name(className)
  }, React.createElement(My.ActualInput, {
    name: id || name,
    checked: checked,
    value: value,
    onChange: handleChange,
    type: "checkbox"
  }), React.createElement(My.Label, null, label || children, required && '*'), React.createElement(My.Checkbox, {
    valid: valid
  }, checked && React.createElement(My.Icon, null, React.createElement(Icon, {
    variant: 'glyph'
  }))));
};
InputCheckbox.defaultProps = InputCheckboxDefaultProps;
InputCheckbox.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;